<div class="label" [class.active]="innerMenuActive" (click)="onClick($event)">
  <span *ngIf="label">{{ label }}</span>
  <ng-content select="[icn-navbar-menu-item-header]"></ng-content>
  <span class="keyboard-shortcut" *ngIf="keyboardShortcut">{{
    keyboardShortcut
  }}</span>

  <i
    class="fa fa-angle-right menu-arrow"
    [hidden]="!hasInnerMenu"
    [ngClass]="{ expanded: innerMenuActive }"
  ></i>
  <ng-content select="[icn-navbar-menu-item-content]"></ng-content>
</div>
<div class="inner-menu" [hidden]="!hasInnerMenu || !innerMenuActive">
  <ng-content></ng-content>
</div>
